import { render } from "./CardSelect.vue?vue&type=template&id=37ae4cbe&scoped=true&ts=true"
import script from "./CardSelect.vue?vue&type=script&lang=ts"
export * from "./CardSelect.vue?vue&type=script&lang=ts"

import "./CardSelect.vue?vue&type=style&index=0&id=37ae4cbe&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ae4cbe"]])

export default __exports__